export const enum FileDocumentTypes {
  ClientDocs = "ClientDocs",
  CaseFile = "CaseFile",
  UserImage = "UserImage",
  Posting = "Posting",
}
